export default __webpack_public_path__ + "static/media/mTop_1_c2.bf24180e.jpeg";